
export function isPengyang(host = window.location.host) {
  return host === 'xxx.pengyangjiaoyu.com'
}

export function isShuxiangyuan(host = window.location.host) {
  return host === 'b.shuxiangyuan.cn'
}

export function isEdukong(host = window.location.host) {
  return host === 'www.edukong.xyz'
}

export function isXiaoxingxing(host = window.location.host) {
  return host === 'www.xiaoxingxing.xyz' || host === 'xiaoxingxing.xyz'
}

export function isRestrictedAdminHost(host = window.location.host) {
  return isXiaoxingxing(host) || isEdukong(host) || isPengyang(host) || isShuxiangyuan(host)
}
